import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---- Public ---- //
export const fetchProjects = (params = {}) =>
    api.get("/projects", { params }).then((r) => r.data);
export const fetchProject = (id) =>
    api.get(`/projects/${id}`).then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const submitInquiry = (payload) =>
    api.post("/contact", payload).then((r) => r.data);

// ---- Admin ---- //
const adminHeaders = (passcode) => ({ headers: { "X-Admin-Passcode": passcode } });

export const verifyAdmin = (passcode) =>
    api.post("/admin/verify", {}, adminHeaders(passcode)).then((r) => r.data);

export const adminListInquiries = (passcode) =>
    api.get("/admin/inquiries", adminHeaders(passcode)).then((r) => r.data);

export const adminCreateProject = (passcode, payload) =>
    api.post("/admin/projects", payload, adminHeaders(passcode)).then((r) => r.data);

export const adminUpdateProject = (passcode, id, payload) =>
    api.put(`/admin/projects/${id}`, payload, adminHeaders(passcode)).then((r) => r.data);

export const adminDeleteProject = (passcode, id) =>
    api.delete(`/admin/projects/${id}`, adminHeaders(passcode)).then((r) => r.data);

export const adminUpdateSettings = (passcode, payload) =>
    api.put("/admin/settings", payload, adminHeaders(passcode)).then((r) => r.data);

// ---- Clips ---- //
export const fetchClips = (params = {}) =>
    api.get("/clips", { params }).then((r) => r.data);

export const fetchFeaturedReel = () =>
    api.get("/clips/featured-reel").then((r) => r.data);

export const adminListClips = (passcode, params = {}) =>
    api
        .get("/admin/clips", { ...adminHeaders(passcode), params })
        .then((r) => r.data);

export const adminCreateClip = (passcode, payload) =>
    api.post("/admin/clips", payload, adminHeaders(passcode)).then((r) => r.data);

export const adminUpdateClip = (passcode, id, payload) =>
    api.put(`/admin/clips/${id}`, payload, adminHeaders(passcode)).then((r) => r.data);

export const adminDeleteClip = (passcode, id) =>
    api.delete(`/admin/clips/${id}`, adminHeaders(passcode)).then((r) => r.data);

export const adminImportClips = (passcode, urls, category = null) =>
    api
        .post(
            "/admin/clips/import",
            { urls, category },
            adminHeaders(passcode),
        )
        .then((r) => r.data);

export const adminApproveClip = (passcode, id) =>
    api
        .post(`/admin/clips/${id}/approve`, {}, adminHeaders(passcode))
        .then((r) => r.data);

export const adminArchiveClip = (passcode, id) =>
    api
        .post(`/admin/clips/${id}/archive`, {}, adminHeaders(passcode))
        .then((r) => r.data);

export const adminFeatureClip = (passcode, id, featured) =>
    api
        .post(
            `/admin/clips/${id}/feature`,
            { featured },
            adminHeaders(passcode),
        )
        .then((r) => r.data);
